const WonderCard = require("../../entities/Cards/WonderCard");
const Wonders = require("../../Constants/Wonders/Wonders");
const { Definition } = require("../../Constants/CardVersions");

// (in the version given: the base game's, or the expansion's for a card it changed)
const WonderConverter = (wonderName, version) =>
{
    const wonder = Definition(Wonders, wonderName, version);
    return wonder === undefined ? null : new WonderCard(wonderName, wonder);
}

module.exports = WonderConverter;
